import styled from "styled-components";
import title from "@/assets/title1.png";
import { BlockContainer } from "../layouts/style";
import zu1 from "@/assets/zu1.png";
import zu2 from "@/assets/zu2.png";
import zu3 from "@/assets/zu3.png";
import zu4 from "@/assets/zu4.png";
import zu5 from "@/assets/zu5.png";

const AnniversaryServerExclusive = () => {
  return (
    <Container>
      <img src={title} alt="" className="title" />
      <div className="table">
        <div className="zu1"></div>
        <div className="zu2"></div>
        <div className="zu3"></div>
        <div className="zu4"></div>
        <div className="zu5"></div>
      </div>
    </Container>
  );
};

export default AnniversaryServerExclusive;

const Container = styled(BlockContainer)`
  position: relative;
  height: 54rem;
  .title {
    width: 31.31rem;
    height: 12.56rem;
    margin-top: 3rem;
  }

  .table {
    height: 61%;
    width: 100%;
    position: absolute;
    bottom: 15%;
    }
    .zu1{
      width: 18.18rem;
      height: 33.75rem;
      background: url(${zu1});
      position: absolute;
      top:8.5%;
      left:10.5%;
      background-position: center;
      background-size: cover;
      background-repeat: no-repeat;
    }
    .zu2{
      width: 18.18rem;
      height: 16.375rem;
      background: url(${zu2});
      position: absolute;
      top:8.5%;
      left:38%;
      background-position: center;
      background-size: cover;
      background-repeat: no-repeat;
    }
    .zu3{
      width: 18.18rem;
      height: 16.375rem;
      background: url(${zu3});
      position: absolute;
      top:60.5%;
      left:38%;
      background-position: center;
      background-size: cover;
      background-repeat: no-repeat;
    }
    .zu4{
      width: 18.18rem;
      height: 16.375rem;
      background: url(${zu4});
      position: absolute;
      top:8.5%;
      left:66%;
      background-position: center;
      background-size: cover;
      background-repeat: no-repeat;
    }
    .zu5{
      width: 18.18rem;
      height: 16.375rem;
      background: url(${zu5});
      position: absolute;
      top:60.5%;
      left:66%;
      background-position: center;
      background-size: cover;
      background-repeat: no-repeat;
    }
  }
`;
